module.exports = __webpack_public_path__ + "img/Stick-O-Vision-Tutorial.66ac23aa.png";